<template>
  <div>
    <div v-if="$root.$i18n.locale === 'en'" class="error">
      <h3>Translation Missing</h3>
      <p>We apologize that this page has not been translated yet.</p>
    </div>
    <template v-if="init">
      <h2>Newsletter abbestellen</h2>
      <p>
        Mit dem Klick auf folgenden Button wirst du aus dem Newsletter-Verteiler entfernt.
      </p>
      <p>
        Du kannst dich anschließend natürlich wieder für den Erhalt der Newsletter erneut registrieren oder
        die aktuellen Informationen von regelmäßigen Besuchen auf die Webseite beziehen.
      </p>
      <button @click="confirmation">Ich möchte keine weiteren Nachrichten von Didi erhalten.</button>
    </template>
    <template v-else>
      <div v-if="success">
        <h2>Fertig!</h2>
        <p>Du erhältst nun keine Neuigkeiten mehr zu Frechdax ABDL.</p>
        <p>Solltest du dich in Zukunft wieder für die Veranstaltungen interessieren, registriere Dich einfach
          erneut.</p>
      </div>
      <div v-else-if="error">
        <h2>Fehler</h2>
        <p>{{error}}</p>
      </div>
      <div v-else>
        <h2>Verarbeitung läuft...</h2>
      </div>
    </template>
  </div>
</template>


<script>
  const axios = require('axios');
  export default {
    data() {
      return {
        success: null,
        error: null,
        init: true,
      }
    },
    methods: {
      confirmation() {
        this.init = false;
        let id = this.$route.query.id;
        if (!id) {
          this.error = 'Ungültige User ID'
        }
        axios.post('https://contact.frechdax-abdl.de/api/newsletter/unsubscribe', {
          id: id
        }).then(response => response.data)
             .then(() => {
               this.success = true;
             })
             .catch(error => {
               console.error(error);
               this.error = error.response.data;
             })
      }
    }
  }
</script>
